module.exports = __webpack_public_path__ + "img/icon_cart.ab08ffb8.svg";